<mat-sidenav-container class="example-sidenav-container" [hasBackdrop]="false" autosize>
  <mat-sidenav #snav [opened]="true" mode="over">
    <mat-nav-list>
      @for (item of defaults.menuClusters; track item) {
        <span>
          @if (item.ClusterComponents && item.ClusterComponents.length > 0 && item.Enabled === true && isClusterVisible(item)) {
            <span
              >
              <mat-accordion multi>
                <mat-expansion-panel [@.disabled]="true" [expanded]="isClusterExpanded(item)" (opened)="onClusterOpened(item)" (closed)="onClusterClosed(item)">
                  @if (item.IconName != 'group') {
                    <mat-expansion-panel-header
                      (click)="navigateToClusterLanding(item, $event)"
                      (keydown.enter)="navigateToClusterLanding(item, $event)"
                      (keydown.space)="navigateToClusterLanding(item, $event)"
                      matTooltip="{{item.DisplayName}}" matTooltipDisabled="{{isExpanded}}">
                      <mat-panel-title>
                        <div fxLayout="row" fxLayoutAlign="space-between center">
                          @if (item.IconName.includes('img/')) {
                            <mat-icon>
                              <img src="{{item.IconName}}" class="icon-png" alt="{{item.DisplayName}}" />
                            </mat-icon>
                          }
                          @if (!item.IconName.includes('img/')) {
                            <mat-icon>
                              {{item.IconName}}
                            </mat-icon>
                          }
                          @if (isExpanded) {
                            <div>
                              {{item.DisplayName}}
                            </div>
                          }
                        </div>
                      </mat-panel-title>
                    </mat-expansion-panel-header>
                  }
                  @if (item.IconName === 'group') {
                    <mat-expansion-panel-header
                      (click)="navigateToClusterLanding(item, $event)"
                      (keydown.enter)="navigateToClusterLanding(item, $event)"
                      (keydown.space)="navigateToClusterLanding(item, $event)"
                      matTooltip="{{item.DisplayName}}" matTooltipDisabled="{{isExpanded}}">
                      <mat-panel-title>
                        <div fxLayout="row" fxLayoutAlign="space-between center">
                          @if (item.IconName.includes('img/')) {
                            <mat-icon>
                              <img src="{{item.IconName}}" class="icon-png" alt="{{item.DisplayName}}" />
                            </mat-icon>
                          }
                          @if (!item.IconName.includes('img/')) {
                            <mat-icon>
                              {{item.IconName}}
                            </mat-icon>
                          }
                          @if (isExpanded) {
                            <div>{{item.DisplayName}}</div>
                          }
                        </div>
                      </mat-panel-title>
                    </mat-expansion-panel-header>
                  }
                  @for (child of item.ClusterComponents; track child) {
                    <span>
                      @if (child.Enabled === true && !isExternalLink(child.Route)) {
                        <mat-list-item routerLink="{{child.Route}}" routerLinkActive="active"
                          matTooltip="{{child.DisplayName}}"
                          matTooltipDisabled="{{isExpanded}}">
                          <div fxLayout="row" fxLayoutAlign="space-between center" class="leafnode">
                            @if (child.IconName.includes('img/')) {
                              <mat-icon class='sidenav-icon'>
                                <img src="{{child.IconName}}" class="icon-png" alt="{{child.DisplayName}}" />
                              </mat-icon>
                            }
                            @if (!child.IconName.includes('img/')) {
                              <mat-icon class='sidenav-icon'>
                                {{child.IconName}}
                              </mat-icon>
                            }
                            @if (isExpanded) {
                              <div>{{child.DisplayName}}</div>
                            }
                          </div>
                        </mat-list-item>
                      }
                      @if (child.Enabled === true && isExternalLink(child.Route)) {
                        <mat-list-item
                          (click)="externalRedirect(child.Route)"
                          (keydown.enter)="externalRedirect(child.Route)"
                          (keydown.space)="externalRedirect(child.Route)"
                          matTooltip="{{child.DisplayName}}"
                          matTooltipDisabled="{{isExpanded}}">
                          <div fxLayout="row" fxLayoutAlign="space-between center" class="leafnode">
                            @if (child.IconName.includes('img/')) {
                              <mat-icon class='sidenav-icon'>
                                <img src="{{child.IconName}}" class="icon-png" alt="{{child.DisplayName}}" />
                              </mat-icon>
                            }
                            @if (!child.IconName.includes('img/')) {
                              <mat-icon class='sidenav-icon'>
                                {{child.IconName}}
                              </mat-icon>
                            }
                            @if (isExpanded) {
                              <div>{{child.DisplayName}}</div>
                            }
                          </div>
                        </mat-list-item>
                      }
                    </span>
                  }
                </mat-expansion-panel>
              </mat-accordion>
            </span>
          }
          @if ((!item.ClusterComponents || item.ClusterComponents.length === 0) && item.Enabled === true && isClusterVisible(item)) {
            <span
              >
              <mat-list-item routerLink="{{item.Route}}" routerLinkActive="active"
                matTooltip="{{item.DisplayName}}"
                matTooltipDisabled="{{isExpanded}}">
                <div fxLayout="row" fxLayoutAlign="space-between center" class="leafnode">
                  @if (item.IconName.includes('img/')) {
                    <mat-icon>
                      <img src="{{item.IconName}}" class="icon-png" alt="{{item.DisplayName}}" />
                    </mat-icon>
                  }
                  @if (!item.IconName.includes('img/')) {
                    <mat-icon>
                      {{item.IconName}}
                    </mat-icon>
                  }
                  @if (isExpanded) {
                    <div>{{item.DisplayName}}</div>
                  }
                </div>
              </mat-list-item>
            </span>
          }
        </span>
      }
    </mat-nav-list>

    <div class="nav-container sidenav-expand" style="position:relative; top: 20px;display:flex;justify-content:flex-end">
      <button mat-icon-button (click)="isExpanded = !isExpanded" style="float:right">
        @if (!isExpanded) {
          <mat-icon style="font-size:30px;" matTooltip="Expand">chevron_right</mat-icon>
        }
        @if (isExpanded) {
          <mat-icon style="font-size: 30px;" matTooltip="Collapse">chevron_left</mat-icon>
        }
      </button>
    </div>
    <div class="nav-container" style="position:relative; top: 25px;text-align:center; font-weight:bold">
      <span style="color:white">{{version}}</span>
    </div>
  </mat-sidenav>
</mat-sidenav-container>